import { AUDIO_LOADING_STATE, MEDIA_ERRORS, SSL_CERT_ERROR_MESSAGE } from './constant'

export const isAudioRepeatable = ({ errorCode }: { errorCode: number | null }) =>
  (errorCode && (errorCode == MediaError.MEDIA_ERR_NETWORK || errorCode > MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED)) ||
  !navigator.onLine

export const isAudioCorrupted = ({ errorCode }: { errorCode: number | null }) =>
  errorCode && errorCode === MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED
export const isAudioLoading = ({ fallbackMessage }: { fallbackMessage: string | null }) =>
  fallbackMessage == AUDIO_LOADING_STATE

export const isAudioProbingSSL = ({
  errorCode,
  fallbackMessage,
}: {
  errorCode: number | null
  fallbackMessage: string | null
}) =>
  fallbackMessage === AUDIO_LOADING_STATE &&
  (errorCode === MediaError.MEDIA_ERR_NETWORK || errorCode === MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED)

// different browser SSL error pattern
const SSL_CERT_ERROR_PATTERNS = [
  'ERR_CERT_COMMON_NAME_INVALID',
  'ERR_CERT_DATE_INVALID',
  'ERR_CERT_AUTHORITY_INVALID',
  'ERR_SSL',
  'SSL certificate',
]

export function isAudioSSLError(errorMessage: string | null | undefined): boolean {
  if (!errorMessage || typeof errorMessage !== 'string') return false
  const msg = errorMessage.toLowerCase()
  return SSL_CERT_ERROR_PATTERNS.some((pattern) => msg.includes(pattern.toLowerCase()))
}

export function isAudioSSLErrorFallback(fallbackMessage: string | null): boolean {
  return fallbackMessage === SSL_CERT_ERROR_MESSAGE
}

export function getMediaErrorMessage(errorCode: number, errorMessage?: string | null) {
  if (errorMessage && isAudioSSLError(errorMessage)) {
    return SSL_CERT_ERROR_MESSAGE
  }
  const error = MEDIA_ERRORS.find((err) => err.code === errorCode)
  return error?.message || 'Something went wrong. Please refresh the audio.'
}

export function detectSSLErrorForUrl(url: string): Promise<boolean> {
  if (!url || !url.startsWith('https://')) return Promise.resolve(false)
  return fetch(url, { method: 'HEAD', mode: 'cors' })
    .then(() => false)
    .catch((err: unknown) => {
      const msg = err instanceof Error ? err.message : String(err)
      if (isAudioSSLError(msg)) return true
      return msg.toLowerCase().includes('failed to fetch') || msg.toLowerCase().includes('load failed')
    })
}

export const audioPlayerObjCache = new Map<string, HTMLAudioElement>()
